import Image from "next/image";
import Link from "next/link";
import React from "react";
import { BiEnvelopeOpen, BiMap, BiPhoneCall } from "react-icons/bi";
import {
  BsFacebook,
  BsInstagram,
  BsLinkedin,
  BsTwitterX,
  BsYoutube,
} from "react-icons/bs";
import Logo from "../../../public/assets/white_logo.png";
const index = () => {
  return (
    <footer className="bg-[#282930] text-white lg:py-10 custome-clippath-sec">
      <div className="container mx-auto">
        <div className="md:grid hidden xl:grid-cols-4 md:grid-cols-2 xl:gap-20 gap-10 items-center">
          <div className="flex flex-col gap-4 pt-5">
            <Image
              src={Logo}
              alt="footer-logo"
              height={300}
              width={300}
              loading="lazy"
              className=""
            />
            <p className="text-gray-400 text-sm hover:text-red-400">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Quis illo
              nemo explicabo
            </p>
            <ul className="flex items-center flex-row gap-5 !mt-5 !mb-5">
              <li>
                <Link
                  href="#"
                  aria-label={"Facebook"}
                  className="text-xl text-white hover:text-red-400"
                >
                  <BsFacebook />
                </Link>
              </li>
              <li>
                <Link
                  href="#"
                  aria-label={"Instagram"}
                  className="text-xl text-white hover:text-red-400"
                >
                  <BsInstagram />
                </Link>
              </li>
              <li>
                <Link
                  href="#"
                  aria-label={"Linkedin"}
                  className="text-xl text-white hover:text-red-400"
                >
                  <BsLinkedin />
                </Link>
              </li>
              <li>
                <Link
                  href="#"
                  aria-label={"Twitter"}
                  className="text-xl text-white hover:text-red-400"
                >
                  <BsTwitterX />
                </Link>
              </li>
              <li>
                <Link
                  href="#"
                  aria-label={"youtube"}
                  className="text-xl text-white hover:text-red-400"
                >
                  <BsYoutube />
                </Link>
              </li>
            </ul>
          </div>
          <div className="flex flex-col items-start gap-2">
            <h5 className="text-white text-base font-semibold">Services</h5>
            <ul className="flex flex-col gap-2">
              <li className="text-gray-400 text-sm hover:text-red-400">
                <Link href="/coming-soon" className=" " area-label={""}>
                  Sheet Glass
                </Link>
              </li>
              <li className="text-gray-400 text-sm hover:text-red-400">
                <Link href="/coming-soon" className=" " area-label={""}>
                  Mirror Glass
                </Link>
              </li>
              <li className="text-gray-400 text-sm hover:text-red-400">
                <Link href="/coming-soon" className=" " area-label={""}>
                  Liquor Bottles
                </Link>
              </li>
              <li className="text-gray-400 text-sm hover:text-red-400">
                <Link href="/coming-soon" className=" " area-label={""}>
                  Food Bottles
                </Link>
              </li>
            </ul>
          </div>
          <div className="flex flex-col items-start gap-2">
            <h5 className="text-white text-base font-semibold">About Us</h5>
            <ul className="flex flex-col gap-2">
              <li className="text-gray-400 text-sm hover:text-red-400">
                <Link href="" className=" " area-label={""}>
                  Vision
                </Link>
              </li>
              <li className="text-gray-400 text-sm hover:text-red-400">
                <Link href="" className=" " area-label={""}>
                  Infrastructure
                </Link>
              </li>
              <li className="text-gray-400 text-sm hover:text-red-400">
                <Link href="" className=" " area-label={""}>
                  CSR
                </Link>
              </li>
              <li className="text-gray-400 text-sm hover:text-red-400">
                <Link href="" className=" " area-label={""}>
                  Board Report MGT 722-2023
                </Link>
              </li>
              <li className="text-gray-400 text-sm hover:text-red-400">
                <Link href="" className=" " area-label={""}>
                  Board Report MGT 722-2024
                </Link>
              </li>
            </ul>
          </div>

          <div className="flex flex-col items-start gap-2">
            <h5 className="text-white text-base font-semibold ">
              Get In Touch
            </h5>

            <ul className="flex flex-col gap-4">
              <li>
                <Link
                  href=""
                  aria-label={"11/5B, 3rd Floor Pusa Road,  New Delhi -110005"}
                  className="grid grid-cols-5 text-gray-400 hover:text-red-400 !leading-8 text-sm"
                >
                  <BiMap className="!mt-1 opacity-40" />{" "}
                  <span className=" col-span-4 font-jakarta text-sm ">
                    15 th Floor, Vijaya Building, <br /> Barakhamba Road, <br />{" "}
                    Connaught Place, Delhi 110001
                  </span>
                </Link>
              </li>
              <li>
                <Link
                  href="mailto:	info@emergeglass.in"
                  aria-label={"	info@emergeglass.in"}
                  className="grid grid-cols-5 text-gray-400 text-sm hover:text-red-400 relative"
                >
                  <BiEnvelopeOpen className="!mt-1 opacity-40" />{" "}
                  <span className=" col-span-4">info@emergeglass.in</span>
                </Link>
              </li>

              <li>
                <Link
                  href="tel:+911141232400"
                  aria-label={"911141232400 "}
                  className="grid grid-cols-5 text-gray-400  hover:text-red-400 text-sm"
                >
                  <BiPhoneCall className="!mt-1 opacity-40" />{" "}
                  <span className=" col-span-4  ">234 3834 5494 </span>
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="!mt-8">
          <hr className="text-[#888]" />
          <ul className="!my-5">
            <li className="flex justify-between items-center xl:flex-row flex-col !px-2">
              <p className="text-gray-400 text-xs">
                ©2025 | All Rights reserved
              </p>
            </li>
          </ul>
          <hr className="text-[#888]" />
        </div>
      </div>
    </footer>
  );
};

export default index;
